import type { TimeRange } from "../../app/state/view/timeline/TimeRange";
import type { DashboardWidgetSpec } from "../../common/dashboard-spec";

import { FormState } from "./_form-state";

interface DrawerState {
	id?: string;

	type: "create" | "edit";
	timeRange: TimeRange;
	form: FormState;
	onSave: (value: DashboardWidgetSpec) => void;
}

type CreateParams = Pick<DrawerState, "id" | "timeRange" | "onSave">;

function create(params: CreateParams): DrawerState {
	return {
		...params,
		type: "create",
		form: FormState.init(),
	};
}

interface EditParams extends Pick<DrawerState, "id" | "timeRange" | "onSave"> {
	widget: DashboardWidgetSpec;
}

function edit({ widget, ...params }: EditParams): DrawerState {
	return {
		...params,
		type: "edit",
		form: FormState.init(widget),
	};
}

const DrawerState = { create, edit };

export { DrawerState };
export type { CreateParams, EditParams };
